import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { Modal } from 'react-bootstrap'

import { store } from 'store/index'
import { SHOW_LOADER, HIDE_LOADER } from 'store/loader/actions'
import ReactSelect from 'pages/parts/ReactSelect'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { handleDecimalKeyDown } from 'helpers/decimalKey'
import { formatDate, formatMoney, notify, returnMinDate } from 'helpers/helpers'

function CreateUpdate() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const reduxAccount = useSelector(state => state.account)

	const [wms, setWms] = useState([])
	const [items, setItems] = useState([])
	const [elementsDuplicate, setElementsDuplicate] = useState([])
	const [modalTemplate, setModalTemplate] = useState({ 'bool': false, 'templates': [] })
	const [data, setData] = useState({
		"items": [{
			'price': '',
			'quantity': '',
			'element_id': ''
		}],
		"quantity": 0,
		"cost_price": 0,
		"total_amount": 0,
		"note": null,
		"user_login": null,
		"activeIndex": 0,
		"created_at": formatDate(new Date(), 'yyyy-MM-dd'),
	})

	async function createUpdate() {
		var dataCopy = { ...data }

		for (let i = 0; i < dataCopy.items.length; i++) {
			if (!dataCopy.items[i]['quantity']) {
				dataCopy.error = true
			}
		}

		if (dataCopy.error) {
			notify(t('check_filled_inputs'))
			return
		}

		var response;
		if (dataCopy.id) {
			response = await PUT('/documents-disasembly', dataCopy, { loader: true })
		} else {
			response = await POST('/documents-disasembly', dataCopy, { loader: true })
		}

		if (httpOk(response)) navigate('/documents-disasembly')
	}

	function handleInputChange(e, index) {
		var dataCopy = { ...data }
		dataCopy.items[index][e.target.name] = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '')

		for (let i = 0; i < dataCopy.items[index]['ingredients'].length; i++) {
			dataCopy.items[index]['ingredients'][i]['actual_quantity'] =
				Number(
					dataCopy.items[index]['ingredients'][i]['quantity'] *
					dataCopy.items[index]['quantity']
				).toFixed(4)
		}

		countTotalAmount(dataCopy)
	}

	function handleIngredientChange(e, index) {
		var dataCopy = { ...data }
		dataCopy.items[dataCopy.activeIndex]['ingredients'][index]['actual_quantity'] = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '')

		countTotalAmount(dataCopy)
	}

	function countTotalAmount(dataCopy) {
		dataCopy.cost_price = 0
		dataCopy.total_amount = 0
		dataCopy.total_quantity = 0

		for (let i = 0; i < dataCopy.items.length; i++) {
			const ingredients = dataCopy.items[i]?.ingredients;

			if (Array.isArray(ingredients) && ingredients.length > 0) {
				for (let j = 0; j < ingredients.length; j++) {
					dataCopy.items[i]['actual_cost_price'] =
						(ingredients[j]?.actual_quantity ?? 0) *
						(ingredients[j]?.cost_price ?? 0);
				}
			} else {
				// если ингредиентов нет, ставим 0
				dataCopy.items[i]['actual_cost_price'] = 0;
			}
		}

		for (let i = 0; i < dataCopy.items.length; i++) {
			dataCopy.total_quantity += Number(dataCopy.items[i]['quantity'])
			dataCopy.total_amount += Number(dataCopy.items[i]['quantity']) * Number(dataCopy.items[i]['cost_price'])
		}

		setData(dataCopy);
	}

	function calculateQuantity(item) {
		var dataCopy = { ...data }
		var index = dataCopy.activeIndex
		dataCopy.items[index]['quantity'] = Number(item.actual_quantity / item.quantity).toFixed(4)

		for (let i = 0; i < dataCopy.items[index]['ingredients'].length; i++) {
			dataCopy.items[index]['ingredients'][i]['actual_quantity'] =
				Number(
					dataCopy.items[index]['ingredients'][i]['quantity'] *
					dataCopy.items[index]['quantity']
				).toFixed(4)
		}

		countTotalAmount(dataCopy)
	}

	function returnIngredients() {
		const item = data?.items?.[data.activeIndex];

		if (item?.ingredients?.length) {
			return item.ingredients;
		}

		return [];
	}

	// REACT SELECT LOGIC
	function handleSelectSearch(value) {
		if (!value) return
		var elementsDuplicateCopy = [...elementsDuplicate]

		var filteredItems = elementsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setItems(filteredItems)
	}

	async function handleSelectItem(option, index) {
		var dataCopy = { ...data }
		dataCopy.items[index]['id'] = option.id
		dataCopy.items[index]['name'] = option.name
		dataCopy.items[index]['balance'] = option.balance
		dataCopy.items[index]['unit_name'] = option.unit_name
		dataCopy.items[index]['cost_price'] = Number(option.cost_price)
		dataCopy.items[index]['in_product'] = option.in_product
		dataCopy.items[index]['write_off_type'] = option.write_off_type

		const response = await GET(`/documents-preparation-ingredients?product_id=${option.id}&wms_id=${data.from_wms_id}`, {}, { loader: true })
		if (httpOk(response)) {
			dataCopy.items[index]['ingredients'] = response.data
			countTotalAmount(dataCopy)
		}
	}

	function closeMenu() {
		setTimeout(() => {
			var elementsCopy = [...items]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i].selected = false
			}
			elementsCopy[0].selected = true
			setItems(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = items.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...items]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[items.length - 1].selected = true
						currentIndex = items.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === items.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setItems(elementsCopy)
		}
	}
	// REACT SELECT LOGIC

	// TEMPLATE LOGIC

	async function toggleModalTemplate(bool) {
		if (bool) {
			const response = await GET(`/documents-disasembly-templates?wms_id=${data.wms_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': response })
			}
		} else {
			setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': [] })
		}
	}

	function handleSelectTemplate(item) {
		setData({ ...data, items: item.items })
		toggleModalTemplate(false)
	}

	async function deleteTemplate(item) {
		await DELETE(`/documents-disasembly-templates/${item.document_order_id}`, {}, { loader: true })
		toggleModalTemplate(false)
	}
	// TEMPLATE LOGIC

	async function getData() {
		store.dispatch(SHOW_LOADER());

		var response
		response = await GET(`/helper/wms?pos_id=${reduxAccount.pos_id}`, {}, { loader: true })
		if (httpOk(response)) setWms(response.data)

		store.dispatch(HIDE_LOADER());
	}

	async function getProducts(wmsId) {
		const response = await GET(`/documents-preparation-products?wms_id=${wmsId}`, {}, { loader: true })
		if (httpOk(response)) {
			setItems(response.data)
			setElementsDuplicate(response.data)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('disasembly')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('create')}</h6>
					</div>
				</div>
				<div className="d-flex gap-1">
					<button type="button" className="btn btn-primary btn-rounded"
						onClick={() => toggleModalTemplate(true)}>
						{t('templates')}
					</button>
				</div>
			</div>

			<form autoComplete="off">
				<div className="card mb-3">
					<div className="card-body">
						<div className="row">
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('date')}<span className="required-mark">*</span></label>
									<div className="calendar-input">
										<DatePicker
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											yearDropdownItemNumber={2}
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={data.created_at ? new Date(data.created_at) : ''}
											onChange={(date) => setData({ ...data, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
											minDate={returnMinDate(new Date(), 20)}
											maxDate={new Date()} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('from_warehouse')}<span className="required-mark">*</span></label>
									<Select
										options={wms}
										value={wms.find(option => option.id === data.from_wms_id)}
										onChange={(option) => {
											setData({ ...data, 'from_wms_id': option.id })
											getProducts(option.id)
										}}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('to_warehouse')}<span className="required-mark">*</span></label>
									<Select
										options={wms}
										value={wms.find(option => option.id === data.to_wms_id)}
										onChange={(option) => setData({ ...data, 'to_wms_id': option.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control"
										name="note"
										onChange={(e) => setData({ ...data, 'note': e.target.value })} />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="card">
					<div className="card-body">
						<div style={{ 'height': '45%', 'overflow': 'auto' }}>
							<table className="table table-bordered" style={{ 'overflow': 'unset' }}>
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '50%' }}>{t('name2')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
										<th style={{ 'width': '5%' }} className="text-nowrap">{t('unit')}</th>
										<th style={{ 'width': '10%' }} className="text-end">
											{t('quantity')}<span className="required-mark">*</span>
										</th>
										<th style={{ 'width': '10%' }} className="text-end">
											{t('cost_price')}
										</th>
										<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{data?.items?.map((item, index) => (
										<tr key={index}>
											<td className="text-center">
												{index + 1}
											</td>
											<td>
												<ReactSelect
													search={handleSelectSearch}
													value={item.name}
													index={index}
													scrollRef={scrollRef}
													options={items}
													onKeyUp={(e) => {
														if (e.keyCode === 40 || e.keyCode === 38) {
															handleTableKeyDown(e)
														}
													}}
													onClose={() => closeMenu()}
													selectItem={(option) => handleSelectItem(option, index)}
													table={
														<table className="table mb-0">
															<tbody ref={tbodyRef}>
																{items.map((item2, index2) => (
																	<tr
																		id={item2.id}
																		className={"cursor " + ((item2.selected || item2.id === item.element_id) ? 'selected' : '')}
																		tabIndex={-1}
																		key={index2}
																		onClick={() => handleSelectItem(item2, index)}
																		onKeyDown={(e) => handleTableKeyDown(e, item2, index)}>
																		<td style={{ 'width': '50%' }}>{item2.name}</td>
																		<td style={{ 'width': '25%' }} className="text-end text-nowrap">{item2.product_type_name}</td>
																		<td style={{ 'width': '25%' }} className="text-end text-nowrap">{formatMoney(item2.cost_price)}</td>
																	</tr>
																))}
															</tbody>
														</table>
													}
												/>
											</td>
											<td className="text-end">
												{formatMoney(item.balance)}
											</td>
											<td>
												{item.unit_name}
											</td>
											<td className="td-input"
												style={!item.quantity ? { 'borderBottom': '2px solid red' } : {}}>
												<input
													type="text"
													name="quantity"
													className="form-control text-end"
													placeholder="0"
													value={item.quantity ?? ''}
													onChange={(e) => handleInputChange(e, index)}
													onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))} />
											</td>
											<td className="text-end">
												{formatMoney(item.actual_cost_price)}
											</td>
											<td className="text-end text-nowrap vertical-middle">
												{formatMoney(item.quantity * item.actual_cost_price)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<div className="position-relative" style={{ 'height': '3%' }}>
							<span style={{ 'position': 'absolute', 'top': '-10px' }}>{t('ingredients')}</span>
							<hr />
						</div>
						<div style={{ 'height': 'calc(100vh - 420px)', 'overflow': 'auto' }}>
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '20%' }}>{t('name2')}</th>
										<th style={{ 'width': '10%' }}>{t('type')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
										<th style={{ 'width': '10%' }}>{t('unit')}</th>
										<th style={{ 'width': '20%' }} className="text-end">{t('cost_price')}</th>
										<th style={{ 'width': '20%' }} className="text-end">1-{t('cost_price')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
									</tr>
								</thead>
								<tbody>
									{returnIngredients().map((item, index) => (
										<tr key={index}>
											<td className="text-center">{index + 1}</td>
											<td>{item.name}</td>
											<td>{item.product_type_name}</td>
											<td className="text-end">{formatMoney(item.quantity, 4)}</td>
											<td className="td-input">
												<input
													type="text"
													name="actual_quantity"
													className="form-control text-end"
													placeholder="0"
													value={item.actual_quantity ?? ''}
													onChange={(e) => handleIngredientChange(e, index)}
													onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleIngredientChange(event, index))}
													onKeyUp={(e) => {
														if (e.keyCode === 13) {
															calculateQuantity(item)
														}
													}} />
											</td>
											<td>{item.unit_name}</td>
											<td className="text-end">{formatMoney(item.cost_price * item.actual_quantity, 2)}</td>
											<td className="text-end">{formatMoney(item.cost_price, 2)}</td>
											<td className="text-end text-nowrap">{formatMoney(item.balance, 2)}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>

						<div className="btn-wrapper gap-2">
							<Link to="/documents-disasembly"
								className="btn btn-warning btn-rounded btn-wide"
								tabIndex="-1">
								{t('cancel')}
							</Link>
							<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
								onClick={() => createUpdate(1)}>
								{t('confirm')}
							</button>
						</div>
					</div>
				</div>
			</form>

			{/* MODAL TEMPLATE */}
			<Modal show={modalTemplate.bool} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModalTemplate(false)
				}>
				<Modal.Header closeButton>
					<Modal.Title>{t('templates')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered table-hover cursor mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '10px' }}>#</th>
									<th>{t('name2')}</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{modalTemplate?.templates?.map((item, index) => (
									<tr key={index}>
										<td>{index + 1}</td>
										<td onClick={() => handleSelectTemplate(item)}>
											{item.name}
										</td>
										<td>
											<div className="d-flex justify-content-end">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deleteTemplate(item)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TEMPLATE */}
		</>
	)
}

export default CreateUpdate